<div class="box-theme">
  <div class="head">
    <div class="header">
      <div class="ico">
        <img src="./assets/img/icon-12.png" alt="Duplicado de boleta">
      </div>
    </div>
    <div class="body">
      <h1>Duplicado de boleta</h1>
      <p></p>
    </div>
  </div>
  <div class="body">
    <div class="div-linea-titulo">
      <div class="linea-titulo"></div>
    </div>
  </div>
  <div class="body">
    <div class="header">
      <h2>
        Para obtener duplicado de boleta puedes solicitarlo de forma digital en tu sucursal virtual <br>
        de Mi Cuenta Online, sin moverte de casa.
      </h2>
    </div>
    <div class="body">

      <div class="row">
        <div class="cont-texto">
          <div>
            <div class="numero">1</div>
            <div class="contenido">En metrogas.cl debes ingresar a sucursalvirtual. </div>
          </div>
        </div>
        <div class="imagen">
          <img src="./assets/img/Duplicado_boleta.png" alt="Debes ingresar con tu Rut y contraseña en la sección Mi Cuenta Online">
        </div>
      </div>

       <div class="row">
        <div class="cont-texto">
          <div>
            <div class="numero">2</div>
            <div class="contenido">Debes ingresar con tu correo y contraseña</div>
          </div>
        </div>
        <div class="imagen">
          <img src="./assets/img/duplicado-boleta_2.png" alt="En la pestaña Estado de Cuenta se muestra la última boleta vigente, y la puedes desplegar haciendo clic en ver más">
        </div>
      </div>

      <div class="row">
        <div class="cont-texto">
          <div>
            <div class="numero">3</div>
            <div class="contenido">En la sección Ver histórico, puedes descargar las ultimas 12 boletas</div>
          </div>
        </div>
        <div class="imagen">
          <img src="./assets/img/duplicado-boleta_3.png" alt="Si deseas ver boletas anteriores, las puedes revisar haciendo clic en Histórico de boletas">
        </div>
      </div>

      <div class="row">
        <div class="cont-texto">
          <div>
            <div class="numero">4</div>
            <div class="contenido">En historial de Consumo puedes ver los últimos 24 meses.</div>
          </div>
        </div>
        <div>
          <div class="imagen">
            <img src="./assets/img/duplicado-boleta_1.png" alt="En historial de Consumo puedes ver los últimos 24 meses">
          </div>
        </div>
      </div>
    </div>
    <br><br><br>
  </div>
  <div class="body">
    <div class="header">
      <h3>
        Si aun no te registras en la Sucursal Virtual hazlo hoy en metrogas.cl.
      </h3>
    </div>
    <div class="body">
      <div class="row">
        <div class="cont-texto">
          <div>
            <div class="numero">1</div>
            <div class="contenido">Completa tus datos y no olvides tener a mano el número de las últimas boletas para el registro.</div>
          </div>
        </div>
        <div class="imagen-duplicado-boleta">
          <img src="./assets/img/duplicado-boleta_5.png" alt="Completa tus datos y no olvides tener a mano el número de las últimas boletas para el registro">
        </div>
      </div>
      <div class="row">
        <div class="cont-texto">
          <div>
            <div class="numero">2</div>
          </div>
        </div>
        <div>
          <p>
            En la Sucursal Virtual además podrás conocer tus consumos, saber el saldo de tu Metrobolsa, pagar tu boleta y mucho más.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="cont-texto">
          <div>
            <div class="numero">3</div>
          </div>
        </div>
        <div>
          <div class="paga-metrogas">
            <h3>
              <!--Regístrate hoy en la Sucursal Virtual <a href="https://sucursalvirtual.metrogas.cl/ingreso/bienvenida" target="_blank">aquí</a>-->
              Regístrate hoy en la Sucursal Virtual <a href="https://sucursalvirtual.metrogas.cl/ingreso/bienvenida" target="_blank">aquí</a>
            </h3>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="callToAcction">
        <input type="button" value="VOLVER" class="btn btn-volver" [routerLink]="['/home']">
      </div>
    </div>
  </div>
</div>
